import {
    CURRENCY_CODES,
    DATE_FORMATS,
    PHONE_NUMBER_PREFIXES,
    TIME_ZONES,
} from '../../constants/constants';

export const INITIAL_CREDITOR_FORM = {
    blobStorageName: '',
    alertsEmailAddress: 'client_success@remitter.com',
    timeZone: TIME_ZONES[2],
    companyName: '',
    website: '',
    callbackEmailAddress: '',
    callbackPhoneNumber: '',
    debitCardGateWay: 0,
    creditCardGateWay: 0,
    bankAccountGateWay: 0,
    paypalGateWay: 0,
    paymentPortalUrl: '',
    daysAfterDueTillDefault: 120,
    enableInvoiceChallenge: false,
    baselineDebtAgeToUploadDate: true,
    enablePaymentPlans: true,
    enablePartialPayments: false,
    toggleCompletePaymentPlanOnInitialEndDate: false,
    repaymentWindowInDays: 112,
    minimumAllowableInvoiceAmountForPartial: 100,
    minimumAllowablePartialAmount: 100,
    minimumAllowableInvoiceAmountForPaymentPlan: 0,
    bypassPolicySystem: true,
    industryVertical: 5,
    sendPaymentPlanEmailReminder: true,
    sendPaymentPlanSmsReminder: true,
    dateFormat: DATE_FORMATS[0],
    defaultCurrencyCode: CURRENCY_CODES[0],
    countryPhoneNumberPrefix: PHONE_NUMBER_PREFIXES[0].value,
    isActive: true,

    //sharingEnabled: false,
    //forceDefaultLanguage: false,
    //supportContactNumber: '',
    //failedPaymentRetryEnabled: false,
    //failedPaymentRetryMaximumRetry: 1,
    //failedPaymentRetryEndPaymentPlan: false,
    //failedPaymentRetryIntervalInHours: 24,
    // sharingMessage: '',
    // creditorPortalUrl: 'https://admin.remitter.com',

    //[Creditors].[WebsiteSettings]:
    // websiteDesktopLogo: '',
    // websiteMobileLogo: '',
    // websiteEmailLogo: '',
    // websiteLegalActionText: '',
    // websiteOutstandingText: 'You have an outstanding balance',
    // websiteTermsAndConditions: '',
};

export const VALIDATION_ERRORS = {
    alertsEmailAddress: '',
    callbackEmailAddress: '',
    callbackPhoneNumber: '',
    paymentPortalUrl: '',
    website: '',
    blobStorageName: '',
};
